<template>
    <div class="form-group">
        <label v-if="title && title.trim().length > 0">
            {{ title }} <span class="text-danger">{{ isRequire ? '(*)' : '' }}</span>
        </label>
        <Treeselect :options="options" noResultsText="Không có kết quả..." :placeholder="placeholder ? placeholder : 'Chọn ' + title"
            v-model="localValue"  :default-expand-level="0" :autoSelectDescendants="true" :autoDeselectDescendants="true"
            :flat="true" :searchable="true" :show-count="false" :disabled="isReadOnly" :clearable="isAllowClear"
            value-consists-of="BRANCH_PRIORITY" :multiple="isMultiple" :always-open="false"
            @update:modelValue="handleChange">

            <template #option-label="{ node, shouldShowCount, count, labelClassName, countClassName }">
                <label :class="labelClassName" class="custom-label">
                    {{ node.label }}
                    <span v-if="shouldShowCount" :class="countClassName">({{ count }})</span>
                </label>
            </template>
        </Treeselect>
        <div class="text-danger text-right mb-2" v-if="error">
            {{ error }}
        </div>
    </div>
</template>
<script>
//---- Document https://vue-treeselect.js.org/#disable-branch-nodes ----//
import { defineComponent, watch } from 'vue';
import Treeselect from 'vue3-treeselect';
import 'vue3-treeselect/dist/vue3-treeselect.css';

export default defineComponent({
    name: "TheSelect4",
    components: {
        Treeselect,
    },
    props: {
        id: String,
        title: String,
        placeholder: String,
        options: Array,
        error: String,
        isMultiple: Boolean,
        isReadOnly: Boolean,
        isRequire: Boolean,
        isAllowClear: Boolean,
        initialValue: {
            type: [String, Number, Array],
            default: null,
        },
        dropdownParent: String,
    },
    data() {
        return {
            localValue: this.initialValue, // Create a local copy of the prop
        };
    },
    watch: {
        initialValue: {
            immediate: true,
            handler(newValue) {
                this.localValue = newValue; // Update local value when the prop changes
            },
        },
        localValue(newValue) {
            this.$emit('update:initialValue', newValue); // Emit updates to the parent
        },
    },
    methods: {
        handleChange(newValue) {
            this.localValue = newValue; // Update localValue
            this.$emit('onChange', newValue); // Emit custom onChange event
        },
    },
});

</script>

<style scoped>
.custom-label {
  all: unset !important; /* Xóa toàn bộ CSS kế thừa từ parent */
}

</style>

